// Tiền tệ (GLOSSARY §6). Id theo GLOSSARY. Topbar hiện 2 loại (UI_SPEC §3.1, §5.7); ví giữ thêm
// các tiền tệ nuôi đồ của M2: Bụi, Luyện Khí Thạch, Toái Linh 7 hệ.
import { ELEMENT_IDS } from './elements';

export const TOPBAR_CURRENCIES = ['spiritStone', 'summonTalisman'] as const;
export type TopbarCurrency = (typeof TOPBAR_CURRENCIES)[number];

export const WALLET_CURRENCIES = [
  ...TOPBAR_CURRENCIES,
  'dust',
  'refiningStone',
  ...ELEMENT_IDS.map((e) => `spiritShard.${e}` as const),
] as const;
export type WalletCurrency = (typeof WALLET_CURRENCIES)[number];

export function isWalletCurrency(id: unknown): id is WalletCurrency {
  return typeof id === 'string' && (WALLET_CURRENCIES as readonly string[]).includes(id);
}
